var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgList(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 21,
    viewBox: "0 0 26 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 20.5157V0.515656H26V20.5157H0ZM2.16667 6.47994H5.99444V2.65851H2.16667V6.47994ZM8.16111 6.47994H23.8333V2.65851H8.16111V6.47994ZM8.16111 12.4085H23.8333V8.6228H8.16111V12.4085ZM8.16111 18.3728H23.8333V14.5514H8.16111V18.3728ZM2.16667 18.3728H5.99444V14.5514H2.16667V18.3728ZM2.16667 12.4085H5.99444V8.6228H2.16667V12.4085Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgList);
export default __webpack_public_path__ + "static/media/list.8b594c49ec946a026676cbfc1a698ccf.svg";
export { ForwardRef as ReactComponent };